<form
  [ngClass]="
    isExistingNumber
      ? 'field-dialog__content__scroll disabled-content form-height p-24'
      : 'field-dialog__content__scroll disabled-content p-24'
  "
  fxLayout="column"
  name="form"
  [formGroup]="approvalForm"
  fusePerfectScrollbar
>
  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="33" fxFlex.xs="100" class="pr-4">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.NUMBER' | translate }}</mat-label>
      <mat-icon
        class="number-duplicated__icon"
        matTooltipClass="custom-tooltip"
        matTooltip="{{ 'APPROVALS_EQUIPMENTS.NUMBER_IN_USE' | translate }}"
        [matTooltipPosition]="'below'"
        *ngIf="isExistingNumber"
      >
        warning
      </mat-icon>
      <input matInput formControlName="number" [ngClass]="{ 'number-duplicated__input': isExistingNumber }" />
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="34" fxFlex.xs="100" class="px-4">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.NAME' | translate }}</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="33" fxFlex.xs="100" class="pl-4">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.TYPE' | translate }}</mat-label>
      <input matInput formControlName="type" />
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start start">
    <div class="pr-4" fxFlex="10" fxFlex.xs="20">
      <img
        (error)="$event.target.src = 'https://ui-avatars.com/api/?name=' + approval.company.name"
        [src]="approval.company.avatarUrl"
        alt="company logo"
        class="company-logo"
      />
    </div>
    <mat-form-field appearance="legacy" fxFlex="90" fxFlex.xs="80" class="pl-4">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.COMPANY' | translate }}</mat-label>
      <input matInput formControlName="company" />
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="34" fxFlex.xs="100" class="pl-4">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.APPROVAL_CREATED_AT' | translate }}</mat-label>
      <input matInput formControlName="approvalCreatedAt" />
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="33" fxFlex.xs="100" class="pl-4">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.APPROVAL_STATUS' | translate }}</mat-label>
      <input matInput formControlName="approvalStatus" />
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="33" fxFlex.xs="100" class="pl-4">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_STATUS' | translate }}</mat-label>
      <input matInput formControlName="equipmentStatus" />
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.QR_CODE' | translate }}</mat-label>
      <input matInput formControlName="qrCode" />
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.LOCATION' | translate }}</mat-label>
      <input matInput formControlName="locationName" />
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.ADDRESS' | translate }}</mat-label>
      <textarea
        matInput
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="3"
        formControlName="locationFormattedAddress"
      ></textarea>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.COMMENTS' | translate }}</mat-label>
      <textarea
        matInput
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="4"
        formControlName="notes"
      ></textarea>
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_LOCATION_SECTOR' | translate }}</mat-label>
      <textarea
        matInput
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="4"
        formControlName="locationSectorName"
      ></textarea>
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'APPROVALS_EQUIPMENTS.DIALOG.EQUIPMENT_LOCATION_ENVIRONMENT' | translate }}</mat-label>
      <textarea
        matInput
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="4"
        formControlName="locationEnvironmentName"
      ></textarea>
    </mat-form-field>
  </div>

  <div *ngIf="isExistingNumber" class="number-duplicated-message" fxLayout="row">
    <mat-icon
      class="number-duplicated-message__icon"
      matTooltip="{{ 'APPROVALS_EQUIPMENTS.NUMBER_DUPLICATED' | translate }}"
      [matTooltipPosition]="'right'"
      >warning</mat-icon
    >

    <span class="number-duplicated-message__message">
      {{ 'APPROVALS_EQUIPMENTS.NUMBER_DUPLICATED' | translate }}
    </span>
  </div>
</form>
